import React, {useEffect, useState} from 'react';
import {useRecoilValue} from 'recoil';

import {UserType} from '@bidmii/common/lib/server/IServerApi';

import {userState} from '../../../../recoil/user/userAtom';
import {MobileFooterContractor} from './MobileFooterContractor';
import {MobileFooterHomeowner} from './MobileFooterHomeowner';
import {
  getSelectedIndexFromCurrentUrl,
  NavigationPath,
} from '../SelectedIndexUtil';

interface IProps {
  width: number;
  removeFooter: boolean;
}

export const FooterNavigationBar: React.FC<IProps> = (props) => {
  const user = useRecoilValue(userState);

  const [selectedIndex, setSelectedIndex] = useState(NavigationPath.DEFAULT);

  useEffect(() => {
    setSelectedIndex(getSelectedIndexFromCurrentUrl());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);

  if (props.width > 600 || props.removeFooter || !user) {
    return null;
  }
  if (
    user.userType === UserType.REQUESTER ||
    localStorage.getItem('userType') === UserType.REQUESTER
  ) {
    return <MobileFooterHomeowner selectedIndex={selectedIndex} user={user} />;
  } else if (user && user.userType === UserType.BIDDER) {
    return <MobileFooterContractor selectedIndex={selectedIndex} user={user} />;
  }
  return null;
};
